module.exports = "<div class=\"ad-container\" [ngClass]=\"{'container': type == 'row'}\" [innerHtml]=\"template | sanitizeIframe\">\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/ad/ad.template.html
// module id = 838
// module chunks = 2